import { ProcessActions, ProcessActionTypes } from '../actions/process.actions';
import { ProcessModel } from '../process.model';

export interface ProcessState {
  process: ProcessModel;
}

export const initialProcessState: ProcessState = {
  process: null,
};

export function processesReducer(
  state = initialProcessState,
  action: ProcessActions
): ProcessState {
  switch (action.type) {
    case ProcessActionTypes.LOAD_JOB_PROCESS:
      return { ...state, process: null };

    case ProcessActionTypes.LOAD_JOB_PROCESS_SUCCESS:
      return { ...state, process: action.payload.process };

    case ProcessActionTypes.UPDATE_JOB_PROCESS_STEP:
      const updatedSteps = state.process.steps.map(step =>
        action.payload.id === step.id
          ? {
              ...step,
              ...action.payload.changes,
            }
          : step
      );
      return {
        ...state,
        process: {
          ...state.process,
          steps: updatedSteps,
        },
      };
    case ProcessActionTypes.CREATE_JOB_PROCESS:
      return {
        ...state,
        process: null,
      };
    case ProcessActionTypes.CREATE_JOB_PROCESS_SUCCESS:
      return {
        ...state,
        process: action.payload.process,
      };
    case ProcessActionTypes.UPDATE_JOB_PROCESS_SUCCESS:
      return {
        ...state,
        process: action.payload.process,
      };

    default: {
      return state;
    }
  }
}
